'use client';

import type { ReactNode } from 'react';
import type { Theme, SxProps } from '@mui/material/styles';

import Stack from '@mui/material/Stack';

import { PAGE_GAP } from 'src/theme/ui-tokens';

/**
 * 화면 골격의 **세로 두 구역** — 상단(머리·검색칸·조건 줄·띠)과 본문(탭·결과).
 *
 * 🔑 사이는 여기 하나가 준다 — 상단 안은 `PAGE_GAP.top`, 상단과 본문 사이는 한 단계 넓은 `PAGE_GAP.zone`.
 *   `HubShell` · `MomentPageLayout` · Research 갈래가 이것을 깐다.
 * ⛔ 안에 넣는 블록에 `mt`/`mb` 를 달지 마라 — gap 과 더해져 그 자리만 붕 뜬다. 띠를 숨길 때는 `null` 을 넘긴다.
 * ⚠️ `top` 은 조각(`<>…</>`)으로 넘겨도 된다 — 낱낱이 상단 구역의 줄이 된다.
 */
export function PageZones({ top, children, sx }: { top?: ReactNode; children?: ReactNode; sx?: SxProps<Theme> }) {
  return (
    <Stack spacing={PAGE_GAP.zone} useFlexGap sx={sx}>
      {top ? (
        <Stack spacing={PAGE_GAP.top} useFlexGap>
          {top}
        </Stack>
      ) : null}
      {children}
    </Stack>
  );
}
